export const TENANT = 'vistaprint';
export const CB_GCP_API_KEY = 'O2dfIJycYw2KqSfmicLxI2rILGAN0ALH5daiQApz';

export const DISPLAY_NAME = {
  CHATBOT: 'Vista Assistant',
  USER: '',
};

export const CHAT_BUTTON_TEXT = {
  CHATBOT: 'Need help?',
  MIAW_CHAT: 'Chat with us',
};

export const CHAT_HEADER_TEXT = {
  CHATBOT: 'Vista Assistant',
  MIAW_CHAT: 'Chat with a specialist',
};
